import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Input, {InputAdornment, InputLabel} from 'material-ui/Input'
import {FormControl} from 'material-ui/Form'
import Payment from 'payment'
import {
  Icon_Visa as CardVisaIcon,
  Icon_AmericanExpress as CardAmericanExpressIcon,
  Icon_CreditCardOutline as CardUnknownIcon,
  Icon_DinersClub as CardDinersClubIcon,
  Icon_Discover as CardDiscoverIcon,
  Icon_JCB as CardJCBIcon,
  Icon_MasterCard as CardMasterCardIcon,
} from 'material-ui-credit-card-icons'
import Select from 'material-ui/Select'
import {MenuItem} from 'material-ui/Menu'

import {creditCardInput as text} from '../text'

class Icon extends React.Component {

  static style = theme => ({})

  render() {
    switch (this.props.type) {
      case 'visa':
        return <CardVisaIcon style={this.props.style}/>
      case 'master':
      case 'mastercard':
        return <CardMasterCardIcon style={this.props.style}/>
      case 'discover':
        return <CardDiscoverIcon style={this.props.style}/>
      case 'amex':
        return <CardAmericanExpressIcon style={this.props.style}/>
      case 'jcb':
        return <CardJCBIcon style={this.props.style}/>
      case 'diners':
      case 'dinersclub':
        return <CardDinersClubIcon style={this.props.style}/>
      default:
        return <CardUnknownIcon style={this.props.style}/>
    }
  }

  static propTypes = {
    type: PropTypes.string,
  }
}

class Number extends React.Component {

  static style = theme => ({
    cardIcon: {
      position: 'relative',
      top: -3,
    },
    input: {
      position: 'relative',
      top: -3,
    },
  })

  state = {
    number: '',
    error: false,
    type: '',
  }

  formatCreditCardNumber = input => {
    if (input) Payment.formatCardNumber(input)
  }

  handleNumberChange = e => {
    const number = e.target.value
    const state = {
      number: number,
      error: this.isCardNumberInputValid(number) === false,
      type: Payment.fns.cardType(number),
    }
    this.setState({...state})
    this.props.onChange(state.number.replace(/\s/g, ''), state.error, state.type)
  }

  isCardNumberInputValid = number => {
    if (number === '') return true
    return Payment.fns.validateCardNumber(number)
  }

  render() {
    const {classes, margin, autoFocus} = this.props
    return (
      <FormControl error={this.state.error} fullWidth margin={margin}>
        <Input
          inputRef={this.formatCreditCardNumber}
          id="number"
          autoFocus={autoFocus}
          value={this.state.number}
          placeholder={text.number.placeholder}
          onChange={this.handleNumberChange}
          classes={{input: classes.input}}
          startAdornment={
            <InputAdornment
              position="start"
              className={classes.cardIcon}
            >
              <Icon type={this.state.type}/>
            </InputAdornment>
          }
        />
      </FormControl>
    )
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    margin: PropTypes.oneOf(['none', 'dense', 'normal']),
    autoFocus: PropTypes.bool,
  }

  static defaultProps = {
    margin: 'none',
    autoFocus: false,
  }
}

class Expiry extends React.Component {

  static style = theme => ({
    input: {},
  })

  state = {
    value: '',
    error: false,
  }

  format = input => {
    if (input) Payment.formatCardExpiry(input)
  }

  handleChange = e => {
    const value = e.target.value
    const state = {
      value: value,
      error: this.isInputValid(value) === false,
    }
    this.setState({...state})
    const data = state.value.split(' / ')
    this.props.onChange(data[0], data[1], state.error)
  }

  isInputValid = value => {
    if (value === '') return true
    return Payment.fns.validateCardExpiry(value)
  }

  render() {
    const {classes, margin, inputStyle} = this.props
    return (
      <FormControl error={this.state.error} margin={margin} style={inputStyle}>
        <InputLabel htmlFor="expiry">{text.expiry.label}</InputLabel>
        <Input
          id="expiry"
          inputRef={this.format}
          value={this.state.value}
          placeholder={text.expiry.placeholder}
          onChange={this.handleChange}
          classes={{
            input: classes.input,
          }}
        />
      </FormControl>
    )
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  }

  static defaultProps = {
    margin: 'none',
    inputStyle: {}
  }
}

class CVC extends React.Component {

  static style = theme => ({})

  state = {
    value: '',
    error: false,
  }

  format = input => {
    if (input) Payment.formatCardCVC(input)
  }

  handleChange = e => {
    const value = e.target.value
    const state = {
      value: value,
      error: this.isInputValid(value) === false,
    }
    this.setState({...state})
    this.props.onChange(state.value, state.error)
  }

  isInputValid = value => {
    if (value === '') return true
    return Payment.fns.validateCardCVC(value, this.props.type)
  }

  render() {
    const {margin, inputStyle} = this.props
    return (
      <FormControl error={this.state.error} margin={margin} style={inputStyle}>
        <InputLabel htmlFor="cvc">{text.cvc.label}</InputLabel>
        <Input
          id="cvc"
          inputRef={this.format}
          value={this.state.value}
          placeholder={text.cvc.placeholder}
          onChange={this.handleChange}
        />
      </FormControl>
    )
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    margin: PropTypes.oneOf(['none', 'dense', 'normal']),
    type: PropTypes.string,
  }

  static defaultProps = {
    margin: 'none',
    type: null,
    inputStyle: {}
  }
}

class CardholderName extends React.Component {

  static style = theme => ({})

  state = {
    value: '',
    error: false,
  }

  handleChange = e => {
    const value = e.target.value
    const state = {
      value: value,
      error: this.isInputValid(value) === false,
    }
    this.setState({...state})
    this.props.onChange(state.value, state.error)
  }

  isInputValid = value => {
    if (value === '') return true
    return true
  }

  render() {
    const {margin} = this.props
    return (
      <FormControl error={this.state.error} margin={margin} fullWidth>
        <InputLabel htmlFor="cardholder">{text.cardholderName.label}</InputLabel>
        <Input
          id="cardholder"
          value={this.state.value}
          onChange={this.handleChange}
        />
      </FormControl>
    )
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  }

  static defaultProps = {
    margin: 'none',
  }
}

class DocumentType extends React.Component {

  static style = theme => ({})

  state = {
    value: '',
    error: false,
  }

  handleChange = e => {
    const value = e.target.value
    const state = {
      value: value,
      error: false,
    }
    this.setState({...state})
    this.props.onChange(state.value, state.error)
  }

  render() {
    const {margin} = this.props
    return (
      <FormControl error={this.state.error} margin={margin} fullWidth>
        <InputLabel>{text.documentType.label}</InputLabel>
        <Select
          value={this.state.value}
          onChange={this.handleChange}
          fullWidth={true}
        >
          {this.props.options.map((o, i) => (
            <MenuItem key={i} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    margin: PropTypes.oneOf(['none', 'dense', 'normal']),
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })).isRequired,
  }

  static defaultProps = {
    margin: 'none',
  }
}

class DocumentNumber extends React.Component {

  static style = theme => ({})

  state = {
    value: '',
    error: false,
  }

  handleChange = e => {
    const value = e.target.value
    const state = {
      value: value,
      error: this.isInputValid(value) === false,
    }
    this.setState({...state})
    this.props.onChange(state.value, state.error)
  }

  isInputValid = value => {
    if (value === '') return true
    return true
  }

  render() {
    const {margin} = this.props
    return (
      <FormControl error={this.state.error} margin={margin} fullWidth>
        <InputLabel htmlFor="document-number">{text.documentNumber.label}</InputLabel>
        <Input
          id="document-number"
          value={this.state.value}
          onChange={this.handleChange}
        />
      </FormControl>
    )
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  }

  static defaultProps = {
    margin: 'none',
  }
}

export const CardIcon = withStyles(Icon.style)(Icon)
export const CardNumberInput = withStyles(Number.style)(Number)
export const CardExpiryInput = withStyles(Expiry.style)(Expiry)
export const CardCVCInput = withStyles(CVC.style)(CVC)
export const CardholderNameInput = withStyles(CardholderName.style)(CardholderName)
export const DocumentTypeSelector = withStyles(DocumentType.style)(DocumentType)
export const DocumentNumberInput = withStyles(DocumentNumber.style)(DocumentNumber)



// WEBPACK FOOTER //
// ./src/common/components/CreditCardInput.js